<app-breadcrumb [master]="'Administracja'" [parentName]="'Komunikaty techniczne'" [name]="'Szczegóły'"></app-breadcrumb>

<mat-tab-group>
  <mat-tab label="Dane">
    <app-loading [loading]="loading" [description]="'Pobieranie ustawień ...'"></app-loading>

    <app-chronie-maintenance-window-view
      *ngIf="!modify"
      [maintenance]="maintenance"
      (modifyClicked)="modify = true">
    </app-chronie-maintenance-window-view>

    <app-chronie-maintenance-window-add
      *ngIf="modify"
      [maintenance]="maintenance"
      (closeModification)="modify = false; loadData()">
    </app-chronie-maintenance-window-add>
  </mat-tab>
</mat-tab-group>
